import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListOrdersParams, OrderStatus, VbanStatus } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  APPROVED_LABEL,
  EXT_ORDER_ID_LABEL,
  FORM_CHANNEL_FIELD_LABEL,
  FORM_COMPLETED_FROM_FIELD_LABEL,
  FORM_COMPLETED_TO_FIELD_LABEL,
  FORM_CREATED_FROM_FIELD_LABEL,
  FORM_CREATED_TO_FIELD_LABEL,
  FORM_ORDER_ID_FIELD_LABEL,
  FORM_ORIGIN_FIELD_LABEL,
  FORM_STATUS_FIELD_LABEL,
  NAME_LABEL,
  BD1_LABEL,
  BD2_LABEL,
  BD5_LABEL,
  OWNER_LINK_LABEL,
  PHONE_VALUE_LABEL,
  QINETIC_ID_LABEL,
  STORE_NAME_LABEL,
  QINETIC_BUG_LABEL,
  LIQUIDATION_LABEL,
  TAX_DEDUCTION_LABEL,
  TAX_DEDUCTION_TYPE_LABEL,
  MERCHANT_REFUND_LABEL,
  HAS_QINETIC_ID_LABEL,
  FORM_COMPANY_ID_FIELD_LABEL,
  LAST_OPERATION_LABEL,
  FILTER_LAST_OPERATION_FROM_LABEL,
  FILTER_LAST_OPERATION_TO_LABEL,
  AGREEMENT_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-orders-filters',
  templateUrl: './orders-filters.component.html',
  styleUrls: ['./orders-filters.component.scss'],
})
export class OrdersFiltersComponent {
  @Input() filters?: ListOrdersParams;
  @Output() filter_clear: EventEmitter<ListOrdersParams> = new EventEmitter<ListOrdersParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }
    return [];
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    if (!status) return '';
    return status?.replace(',running', '');
  }

  getVbanStatusLabel(status?: VbanStatus): string {
    if (!status) return '';
    return status;
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    console.log(key);
    switch (key) {
      case 'buyer_name':
        return NAME_LABEL;

      case 'order_id':
        return FORM_ORDER_ID_FIELD_LABEL;

      case 'company_id':
        return FORM_COMPANY_ID_FIELD_LABEL;

      case 'status':
        return FORM_STATUS_FIELD_LABEL;

      case 'channel':
        return FORM_CHANNEL_FIELD_LABEL;

      case 'origin':
        return FORM_ORIGIN_FIELD_LABEL;

      case 'created_from':
        return FORM_CREATED_FROM_FIELD_LABEL;

      case 'created_to':
        return FORM_CREATED_TO_FIELD_LABEL;

      case 'completed_from':
        return FORM_COMPLETED_FROM_FIELD_LABEL;

      case 'completed_to':
        return FORM_COMPLETED_TO_FIELD_LABEL;

      case 'bd1':
        return BD1_LABEL;

      case 'bd2':
        return BD2_LABEL;

      case 'bd5':
        return BD5_LABEL;

      case 'liquidation':
        return LIQUIDATION_LABEL;

      case 'qinetic_id':
        return QINETIC_ID_LABEL;

      case 'store_name':
        return STORE_NAME_LABEL;

      case 'approved':
        return APPROVED_LABEL;

      case 'external_id':
        return EXT_ORDER_ID_LABEL;

      case 'phone_number':
        return PHONE_VALUE_LABEL;

      case 'owner_link':
        return OWNER_LINK_LABEL;

      case 'qinetic_bug':
        return QINETIC_BUG_LABEL;

      case 'has_qinetic_id':
        return HAS_QINETIC_ID_LABEL;

      case 'tax_deduction':
        return TAX_DEDUCTION_LABEL;

      case 'tax_deduction_type':
        return TAX_DEDUCTION_TYPE_LABEL;

      case 'merchant_refund':
        return MERCHANT_REFUND_LABEL;

      case 'last_operation':
        return LAST_OPERATION_LABEL;

      case 'last_operation_from':
        return FILTER_LAST_OPERATION_FROM_LABEL;

      case 'last_operation_to':
        return FILTER_LAST_OPERATION_TO_LABEL;

      case 'agreement':
        return AGREEMENT_LABEL;

      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'buyer_name':
        return this.filters?.buyer_name || '-';

      case 'order_id':
        return this.filters?.order_id || '-';

      case 'company_id':
        return this.filters?.company_id || '-';

      case 'status':
        return this.getOrderStatusLabel(this.filters?.status);

      case 'channel':
        return this.filters?.channel || '-';

      case 'origin':
        return this.filters?.origin || '-';

      case 'created_from':
        return this.toStringDate(this.filters?.created_from || 0);

      case 'created_to':
        return this.toStringDate(this.filters?.created_to || 0);

      case 'completed_from':
        return this.toStringDate(this.filters?.completed_from || 0);

      case 'completed_to':
        return this.toStringDate(this.filters?.completed_to || 0);

      case 'bd1':
        return this.filters?.bd1 || '-';

      case 'bd2':
        return this.filters?.bd2 || '-';

      case 'bd5':
        return this.filters?.bd5 || '-';

      case 'liquidation':
        return this.filters?.liquidation || '-';

      case 'qinetic_id':
        return this.filters?.qinetic_id || '-';

      case 'store_name':
        return this.filters?.store_name || '-';

      case 'approved':
        return this.filters?.approved || '-';

      case 'external_id':
        return this.filters?.external_id || '-';

      case 'phone_number':
        return this.filters?.phone_number || '-';

      case 'owner_link':
        return this.filters?.owner_link || '-';

      case 'qinetic_bug':
        return this.filters?.qinetic_bug || '-';

      case 'has_qinetic_id':
        return this.filters?.has_qinetic_id || '-';

      case 'tax_deduction':
        return this.filters?.tax_deduction || '-';

      case 'tax_deduction_type':
        return this.filters?.tax_deduction_type || '-';

      case 'merchant_refund':
        return this.getVbanStatusLabel(this.filters?.merchant_refund);

      case 'last_operation':
        return this.utils_service.getLastOrderStatusChange(this.filters?.last_operation || '');

      case 'last_operation_from':
        return this.toStringDate(this.filters?.last_operation_from || 0);

      case 'last_operation_to':
        return this.toStringDate(this.filters?.last_operation_to || 0);

      case 'agreement':
        return this.filters?.agreement || '-';

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
